import FileSaver from 'file-saver'
import XLSX from 'xlsx'

export default{
    install (Vue, options) {
      Vue.prototype.getExcelCrossCity = function (hasNanjing,hasWuhan,hasShenzhen,hasChongqing,hasChengdu,data){
       let ws
       let wb = XLSX.utils.book_new()
       let wbout
       
        for(let table of data){
            ws = XLSX.utils.table_to_sheet (document.querySelector('#busTable_'+table.param_json.city+'_'+table.param_json.id))
           
            XLSX.utils.book_append_sheet(wb, ws, table.param_json.city+'_'+table.param_json.clientName)
        }
        /* generate workbook object from table */
        // if(this.hasNanjing){
        //     ws = XLSX.utils.table_to_sheet (document.querySelector('#busTable_Nanjing'))
           
        //     XLSX.utils.book_append_sheet(wb, ws, 'Nanjing')
        // }
        // if(this.hasWuhan){
        //     ws = XLSX.utils.table_to_sheet (document.querySelector('#busTable_Wuhan'))
         
        //     XLSX.utils.book_append_sheet(wb, ws, 'Wuhan')
        // }
        // if(this.hasShenzhen){
        //     ws = XLSX.utils.table_to_sheet (document.querySelector('#busTable_Shenzhen'))
           
        //     XLSX.utils.book_append_sheet(wb, ws, 'Shenzhen')
        // }
        // if(this.hasChongqing){
        //     ws = XLSX.utils.table_to_sheet (document.querySelector('#busTable_Chongqing'))
           
        //     XLSX.utils.book_append_sheet(wb, ws, 'Chongqing')
        // }
        // if(this.hasChengdu){
        //     ws = XLSX.utils.table_to_sheet (document.querySelector('#busTable_Chengdu'))
           
        //     XLSX.utils.book_append_sheet(wb, ws, 'Chengdu')
        // }
         
        /* get binary string as output */
        wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
        try {
            FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'Bus_Media_Solution.xlsx')
        } catch (e) { if (typeof console !== 'undefined') console.log(e, wbout) }
        return wbout
      }
    }
}